<template>
    <v-card elevation="2" outlined>
        <v-card-title>
            سوابق خرید پنل
            <v-spacer/>
            <v-icon>mdi-city-variant</v-icon>
        </v-card-title>
        <v-divider/>
        <v-simple-table>

            <thead>
            <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>قیمت</th>
                <th>تاریخ انقضا (روز)</th>
                <th>مالک</th>
                <th>وضعیت</th>
                <th>تاریخ رزرو</th>
            </tr>
            </thead>

            <tbody>

            <tr v-for="(x, i) in packs" :key="i">
                <td v-text="x.id"/>
                <td v-text="x.title"/>
                <td v-text="x.price"/>
                <td v-text="x.expire"/>
                <td v-text="x.own_number">
                </td>
                <td v-text="x.deleted_at" >
                </td>
                <td v-text="$options.filters.longDate(x.created_at)"/>
            </tr>
            </tbody>
        </v-simple-table>
    </v-card>
</template>

<script>
export default {
    name: "userJobs",

    props: ['packs'],

    methods: {
        getUserFile(url) {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = this.uploadUrl + url;
            a.download;
            a.click();

            document.removeChild(a);
        }
    }
}
</script>

<style scoped>

</style>
